import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserRole } from '@ata-digital/client-tax-system-api-client';
import { AdminDashboard } from '@/features/preparer/admin/AdminDashboard';
import type { AuthState } from '@/hooks/auth/useAuth';

export const Route = createFileRoute('/preparer/admin-dashboard')({
  beforeLoad: ({ context }) => {
    // Check admin role before loading the route.
    // If auth hasn't loaded yet (fresh page load / shared link), let it through —
    // PreparerAuthGuard will handle the auth loading state.
    const authState = (
      context as { queryClient: { getQueryData: (key: string[]) => unknown } }
    ).queryClient.getQueryData(['auth', 'session']) as AuthState | undefined;
    if (authState?.isAuthenticated && authState?.user?.role !== UserRole.Admin) {
      throw redirect({ to: '/preparer' });
    }
  },
  component: AdminDashboard,
});
